var cssPresets = new Map([
    ['clydeBlue', true],
    ['clydeWhite', true],
    ['clydeBlack', true],
    ['clydeLightBlue', true],
    ['clydeAqua', true],
    ['clydeViolet', true],
    ['clydePurple', true],
    ['clydeGreen', true],
    ['clydeGrey', true],
    ['clydeSubduedGrey', true],
]);
export var validateColorPreset = function (preset) {
    if (typeof preset !== 'string') {
        return false;
    }
    if (cssPresets.has(preset)) {
        return true;
    }
    return false;
};
var labelPositionPresets = new Map([
    ['top', true],
    ['right', true],
    ['bottom', true],
    ['left', true],
]);
export var validateLabelPositionPreset = function (preset) {
    if (typeof preset !== 'string') {
        return false;
    }
    if (labelPositionPresets.has(preset)) {
        return true;
    }
    return false;
};
